
import {Component, Vue, Watch} from 'vue-property-decorator';
import ArtistImage from "./ArtistImage.vue";
import {store} from "../Store";
import {searchMatcher} from "../lib/search";


@Component({
    components: {ArtistImage},
})
export default class SongList extends Vue {
    data = store.data;

    get list() {
        const {currentFilter, songs} = this.data;
        return songs.filter(x => searchMatcher(x.title, currentFilter) || x.artist && searchMatcher(x.artist.name, currentFilter))
    }
}
